import React from 'react'
import {   Field} from 'redux-form'

const normalizeNumber = value=>{

    let outValue = value
  
    if(!value){
        return outValue
    }

    const onlyNums = value.replace(/[^\d]/g, '')

    outValue = onlyNums
    console.log(onlyNums)
    return outValue
    //return outValue
}

const svinputRenderField = ({input, label, type, meta:{error, touched}})=>{
    return(
            <input {...input}  component="input" type="input"   className="form-control" /> 
    )

}
export class SVTIInputEp extends React.Component{

    constructor(props){
        super(props)
    }
  
    componentWillReceiveProps(next){
        console.log('props changed SVString')
    }
   
    render(){
        console.log('render tid')
        console.log(this.props)
        let me = this
       let {member,index, placeholder ='Port Z'} = this.props
          return (
            <Field
            normalize={normalizeNumber} 
            name={`${member}.tid`}
            type="text"
            component={svinputRenderField}
            placeholder={placeholder}
            className="form-control"
           
          />)
    }
}